module.exports = __webpack_public_path__ + "static/img/2019中国企业财务共享平台首选品牌厂商奖.4309a95d.png";